import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { GameActions } from "../state/GameReducer.js";
import { DispatchAction } from "../state/State.js";

/**
 * @name BaseCounter
 * @class BaseCounter
 * @extends {ConnectedHTMLElement}
 * @description
 * This component keeps track of the remaining life points of the player.
 */
export class BaseCounter extends ConnectedHTMLElement {
  static observedAttributes = ["player"];

  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    if (
      (oldState.currentGame === undefined &&
        newState.currentGame !== undefined) ||
      newState.currentGame?.ended !== oldState.currentGame?.ended
    ) {
      //only render when a game has started or ended
      this.render();
    }
  }

  registerEvents() {
    const player = this.getAttribute("player");
    const buttons = this.querySelectorAll("button");
    buttons.forEach((b) => {
      b.addEventListener("click", (e) => {
        e.preventDefault();
        const amount = Number(b.dataset.amount);
        if (b.classList.contains("btn-damage")) {
          if (this.state.currentGame?.ended) return;
          DispatchAction(GameActions.damage, { player: player, amount });
        } else if (b.classList.contains("btn-heal")) {
          if (this.state.currentGame?.ended) return;
          if (this.state[player].remainingHp === this.state[player].base.hp)
            return;
          DispatchAction(GameActions.heal, { player: player, amount });
        }
      });
    });
  }

  render() {
    const player = this.getAttribute("player");
    const gameEnded = this.state.currentGame?.ended;
    if (this.state.currentGame === undefined) {
      this.innerHTML = ``;
      return;
    }
    this.innerHTML = `
         <div
          class="p-2 bg-neutral absolute left-0 top-0 w-full z-[45] height-[114px]"
          id="counter"
        >
          <div
            class="flex flex-row place-content-between ${gameEnded ? "hidden" : ""}"
            id="counter-toolbar"
          >
            <div class="flex flex-row">
              <button
                class="btn action-btn btn-heal mr-1"
                id="counter-increment-1"
                data-amount="1"
                ${gameEnded ? "disabled" : ""}
                type="button"
                title="Heal 1"
              >
                <img
                  alt="Medical cross"
                  height="64"
                  src="/assets/icons/heal-1.svg"
                  width="64"
                />
              </button>
              <button
                class="btn action-btn btn-heal mr-1"
                id="counter-increment-3"
                data-amount="3"
                ${gameEnded ? "disabled" : ""}
                type="button"
                title="Heal 3"
              >
                <img
                  alt="Medical cross"
                  height="64"
                  src="/assets/icons/heal-3.svg"
                  width="64"
                />
              </button>
              <button
                class="btn action-btn btn-heal"
                id="counter-increment-5"
                data-amount="5"
                ${gameEnded ? "disabled" : ""}
                type="button"
                title="Heal 5"
              >
                <img
                  alt="Medical cross"
                  height="64"
                  src="/assets/icons/heal-5.svg"
                  width="64"
                />
              </button>
            </div>
            <div class="flex flex-row ${gameEnded ? "hidden" : ""}">
              <button
                class="btn action-btn btn-damage"
                id="counter-decrement-5"
                data-amount="5"
                ${gameEnded ? "disabled" : ""}
                type="button"
                title="Deal 5 damage"
              >
                <img
                  alt="Explosion icon"
                  height="64"
                  src="/assets/icons/damage-5.svg"
                  width="64"
                />
              </button>
              <button
                class="btn action-btn btn-damage"
                id="counter-decrement-3"
                data-amount="3"
                ${gameEnded ? "disabled" : ""}
                type="button"
                title="Deal 3 damage"
              >
                <img
                  alt="Explosion icon"
                  height="64"
                  src="/assets/icons/damage-3.png"
                  width="64"
                />
              </button>
              <button
                class="btn action-btn btn-damage"
                id="counter-decrement-1"
                data-amount="1"
                ${gameEnded ? "disabled" : ""}
                type="button"
                title="Deal 1 damage"
              >
                <img
                  alt="Explosion icon"
                  height="64"
                  src="/assets/icons/damage-1.svg"
                  width="64"
                />
              </button>
            </div>
          </div>
          <game-timer player="${player}"></game-timer>
        </div>`;
    this.registerEvents();
  }
}
